


































import Vue from 'vue'
import Component from 'vue-class-component'

export interface Navigation {
  header: string
  icon: string
  url: string
  navigationItems: NavigationItems[]
  visible: boolean
}
export interface NavigationItems {
  id: number
  title: string
  label: string
  url: string
}
@Component<SideMenu>({
  props: {
    navigation: Array,
    text: String,
    logout: Function,
    logOutText: String
  },
  watch: {
  }
})

export default class SideMenu extends Vue {
  /**
   * Props variables
   */
  text: string | undefined
  logout: Function | undefined
  navigation: Navigation | undefined
  logOutText: string | undefined
  /**
   * Component state variables
   */
  // isMenuOpen: boolean = false


  /**
   * Lifecycle
   */
  // async mounted () {
  // }


  /**
   * Getters
   */


  /**
   * Methods
   */
  async logUserOutCb () {
    if (this.logout !== undefined) {
      await this.logout()
    }
  }

}
